module.exports = __webpack_public_path__ + "static/media/stripe-s.fe6fe698.svg";